import { WSLoader } from "@wingspanhq/fe-component-library";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { PAYEES_ROOT_PATH } from "../../Payees/utils";
import { useBulkReviewRequirements } from "../hooks/useBulkReviewRequirements";

export const RouteBulkReviewRequirements = () => {
  const history = useHistory();
  const { queryRequirements } = useBulkReviewRequirements();

  useEffect(() => {
    const requirement = queryRequirements.data?.pages[0]?.data?.[0];

    if (requirement) {
      history.replace({
        pathname: `/member/payees/${requirement.payeeAccountId}/requirement/${requirement.id}`,
        search: history.location.search
      });
    } else if (queryRequirements.isError || queryRequirements.isSuccess) {
      // No matching requirement (query failed, or succeeded but returned
      // none) — bounce back instead of leaving the user on a blank page.
      history.replace(PAYEES_ROOT_PATH);
    }
  }, [
    queryRequirements.data,
    queryRequirements.isError,
    queryRequirements.isSuccess,
    history
  ]);

  if (queryRequirements.isLoading) {
    return <WSLoader.Spinner />;
  }

  return null;
};
